import { KEY_PREFIX } from './constant'

export const generalKey = (context) => {
  const { meta, fullPath } = context
  return KEY_PREFIX + (meta.id || fullPath)
}

export const setModel = (context, data) => {
  const key = generalKey(context)
  sessionStorage.setItem(key, JSON.stringify(data))
}

export const getModel = key => {
  const value = sessionStorage.getItem(key)
  try {
    return JSON.parse(value)
  } catch (error) {
    console.error(error)
    return null
  }
}

export const isGoBack = (to = {}, from = {}) => {
  const to_path = to.fullPath || ''
  const from_path = from.fullPath || ''
  const { id } = to.meta
  const { parent_id } = from.meta
  if (id && parent_id) return (id === parent_id)
  return to_path.length < from_path.length && from_path.includes(to_path)
}
